/* eslint-disable react/prop-types */
/**
 * SendReportIcon.jsx
 */
import React from 'react'

const SendReportIconDefault = ({ style, fillColor, outlineColor }) => <SendReportIcon style={style} fillColor={fillColor} outlineColor={outlineColor} />

export default SendReportIconDefault

const SendReportIcon = ({ style, solidColor, outlineColor }) => {
  const svg = {
    ...style,
  }

  const fill = solidColor || '#284047'
  const stroke = outlineColor || 'white'
  const filledStyle = {
    fill,
    fillOpacity: 1,
    stroke: fill,
    strokeWidth: 1,
    strokeLinecap: 'butt',
    strokeLinejoin: 'round',
    strokeMiterlimit: 4,
    strokeDasharray: 'none',
    strokeOpacity: 1,
  }

  const outlineStyle = {
    fillOpacity: 1,
    stroke,
    strokeWidth: '2px',
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
    strokeOpacity: 1,
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='50'
      width='50'
      viewBox='0 0 50 50'
      y='0px'
      x='0px'
      id='run-report-icon'
      style={svg}
      version='1.1'
    >
      <title>send report icon</title>
      <g>
        <path style={filledStyle} d='M 1,49 18,31 h 13.7 l 18,18 z' />
        <path style={filledStyle} d='m 1,19 c 0,0 12,-11 18,-15 2,-1.5 3.6,-3.1 6.6,-3.2 1.9,-0 3.1,0.6 6,3 2.7,2.3 18.7,15.1 18.7,15.1 l -17.8,12.3 -13.6,-0.1 -17.9,-12.1' />
        <path style={outlineStyle} fill='none' d='M 8.8,24.6 8.3,12.5 H 42 l -0,12.5 -9.8,6.5 -13.7,-0 z' />
        <path style={filledStyle} d='m 0.5,19.2 17.8,12.2 -17.7,17.6 z' />
        <path style={filledStyle} d='M 49.7,19 32,31.3 49.6,49.4 Z' />
        <g transform='translate(39,2.8)'>
          <path style={outlineStyle} fill='none' d='m -23.5,22.7 6,-6.5 6.6,2.9 7.4,-5.7 -0,0' />
          <circle style={outlineStyle} fill={stroke} r='1.6' cy='22.5' cx='-23' />
          <circle style={outlineStyle} fill={stroke} r='1.6' cy='16' cx='-17' />
          <circle style={outlineStyle} fill={stroke} r='1.6' cy='19' cx='-11' />
          <circle style={outlineStyle} fill={stroke} r='1.6' cy='13.2' cx='-3.4' />
        </g>
        <path style={outlineStyle} fill='none' d='M 0.2,49.6 18.2,31.4 l -17.8,-12.2' />
        <path style={outlineStyle} fill='none' d='M 49.8,49.8 31.9,31.4 49.7,19.1' />
      </g>
    </svg>
  )
}
